import React, { useState, useRef, useEffect } from "react";
import Global from "../../global";
import "./watch.css";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { UserStore } from "../store/store";
import Progress from "../history/progress";
import useWatchHistory from "../../hooks/useWatchHistory";
import CarouselContentLoader from "../loader/contentLoader";
import useCheckVideo from "../../hooks/useCheckVideo";
import JWPlayer from "@jwplayer/jwplayer-react";
import { addForwardButton } from "../javascript/function";
import YoutubeFullPlayer from "../boxedPlayer/youtubeFull";

//const adTag ="https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/ad_rule_samples&ciu_szs=300x250&ad_rule=1&impl=s&gdfp_req=1&env=vp&output=vmap&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ar%3Dpremidpost&cmsid=496&vid=short_onecue&correlator=";

const Watch = (props) => {
  //const video_list = JSON.parse(localStorage.getItem("video_list")) || [];
  const currentUser = UserStore.useState((s) => s.user);
  const [mounted, setMounted] = useState(false);
  const playerRef = useRef({});
  const videoIndex = useRef(
    currentUser.WATCHHISTORY.findIndex(
      (obj) => obj.video_id === props.match.params.Id
    )
  );
  const seeked = useRef(
    videoIndex.current === -1
      ? 0
      : parseInt(currentUser.WATCHHISTORY[videoIndex.current].position)
  );
  const videoRef = useRef(
    props.match.params.Type === "season"
      ? Global.BEW
        ? "https://cdn.jwplayer.com/v2/playlists/" + props.match.params.Id
        : "https://cdn.jwplayer.com/v2/playlists/" +
          props.match.params.Id +
          "?page_limit=1"
      : props.match.params.Type === "episode"
      ? props.match.params.offset && Global.BEW
        ? "https://cdn.jwplayer.com/v2/playlists/" +
          props.match.params.TypeId +
          "?page_offset=" +
          props.match.params.offset
        : props.match.params.offset && !Global.BEW
        ? "https://cdn.jwplayer.com/v2/playlists/" +
          props.match.params.TypeId +
          "?page_offset=" +
          props.match.params.offset +
          "&page_limit=1"
        : Global.BEW
        ? "https://cdn.jwplayer.com/v2/playlists/" + props.match.params.TypeId
        : "https://cdn.jwplayer.com/v2/playlists/" +
          props.match.params.TypeId +
          "?page_limit=1"
      : "https://cdn.jwplayer.com/v2/media/" + props.match.params.Id
  );
  const [videoName, SetVideoname] = useState("");
  const [videoDet, setVideoDet] = useState(null);
  const [meta, setMeta] = useState("");
  const [media_id, SetVideo_ID] = useState(props.match.params.Id);
  const [seek, setSeek] = useState(Global.RPB ? seeked.current : 0);
  /* eslint-disable no-unused-vars */
  const [loading, setLoading] = useState(true);
  /* eslint-disable no-unused-vars */
  let date = new Date();
  let cdate = date.toDateString();
  let ctime = date.toTimeString();
  Progress.video_id = props.match.params.Id;
  Progress.duration =
    videoIndex.current === -1 ||
    isNaN(parseInt(currentUser.WATCHHISTORY[videoIndex.current].duration))
      ? 0
      : parseInt(currentUser.WATCHHISTORY[videoIndex.current].duration);
  Progress.position =
    videoIndex.current === -1 ||
    isNaN(parseInt(currentUser.WATCHHISTORY[videoIndex.current].position))
      ? 0
      : parseInt(currentUser.WATCHHISTORY[videoIndex.current].position);
  Progress.type =
    props.match.params.Type === "season" ||
    props.match.params.Type === "episode"
      ? "season"
      : "";
  Progress.list_id =
    props.match.params.Type === "season"
      ? props.match.params.Id
      : props.match.params.Type === "episode"
      ? props.match.params.TypeId
      : "";
  Progress.date = cdate + " " + ctime;
  Progress.limit = props.match.params.offset ? props.match.params.offset : "";
  Progress.title = videoName;
  const [second, Setsecond] = useState(Progress);
  useWatchHistory(second);
  useCheckVideo(videoDet, props.match.params.AppId, props);
  const history = useHistory();

  useEffect(() => {
    setLoading(false);
  }, []);

  const goBack = () => {
    // watchHistory(second,props.match.params.Id);
    history.goBack();
  };
  const readyPlay = (event) => {
    SetVideoname(event.item.title);

    setVideoDet(event);

    if (
      props.match.params.Type === "season" ||
      props.match.params.Type === "episode"
    ) {
      SetVideo_ID(event.item.mediaid);
      const index = currentUser.WATCHHISTORY.findIndex(
        (obj) => obj.video_id === props.match.params.Id
      );
      if (index > -1) {
        const arr = [...currentUser.WATCHHISTORY];
        arr.splice(index, 1);
      }
    }

    let mins = parseInt(event.item.duration) / 60;
    let time = parseInt(mins);
    setMeta(event.item.Genre + " • " + time + " mins");
    const objIndex = currentUser.WATCHHISTORY.findIndex(
      (obj) => obj.video_id === media_id
    );
    if (objIndex > -1) {
      setSeek(parseInt(currentUser.WATCHHISTORY[objIndex].position));
    } else {
      setSeek(0);
    }

    // }
  };

  const onReady = (event) => {
    if (mounted) {
      playerRef.current.seek(seek);
      addForwardButton(playerRef.current);
    }
  };
  const playerMountedCallback = ({ player }) => {
    playerRef.current = player;
    setMounted(true);
  };
  const playerUnmountingCallback = ({ player }) => {
    playerRef.current = null;
    setMounted(false);
  };

  const watchedHistory = (event) => {
    const obj = {
      duration: event.duration,
      position: event.position,
      video_id: media_id,
      type:
        props.match.params.Type === "season" ||
        props.match.params.Type === "episode"
          ? "season"
          : "",
      list_id:
        props.match.params.Type === "season"
          ? props.match.params.Id
          : props.match.params.Type === "episode"
          ? props.match.params.TypeId
          : "",
      date: cdate + " " + ctime,
      limit: props.match.params.offset ? props.match.params.offset : "",
      title: videoName,
    };
    Setsecond(obj);
  };

  if (!loading) {
    return (
      <div className="watchClass">
        <Helmet>
          <body>
            {`<style type="text/css">
               .jwplayer.jw-flag-aspect-mode
               {
                   height:100vh !important;
               }
               </style>`}
          </body>
        </Helmet>

        {Global.VCMS === "YouTube" ? (
          <YoutubeFullPlayer
            videoId={props.match.params.Id}
            playlistId={
              props.match.params.Type === "season" && Global.BEW
                ? props.match.params.Id
                : props.match.params.Type === "episode" && Global.BEW
                ? props.match.params.TypeId
                : ""
            }
          ></YoutubeFullPlayer>
        ) : (
          <JWPlayer
            library={"https://cdn.jwplayer.com/libraries/" + Global.FSP + ".js"}
            playlist={videoRef.current}
            onTime={watchedHistory}
            onPlaylistItem={readyPlay}
            onReady={onReady}
            didMountCallback={playerMountedCallback}
            playerUnmountingCallback={playerUnmountingCallback}
          ></JWPlayer>
        )}

        {/*  <ReactJWPlayer
          playerId={Global.FSP}
          playerScript={
            "https://cdn.jwplayer.com/libraries/" + Global.FSP + ".js"
          }
          playlist={videoRef.current}
          onVideoLoad={readyPlay}
          seekTo={seek}
          onTime={watchedHistory}
          onReady={onReady}
          
        /> */}

        <div style={{ transition: "opacity 0.25s ease-in-out 0s", opacity: 1 }}>
          <div className="back_wrapper">
            <div className="back_wrap">
              <div
                className="_backbutton _backCrypto"
                aria-label="Back"
                role="button"
                tabIndex={0}
                onClick={goBack}
              >
                <svg
                  className="_backSvg"
                  viewBox="0 0 24 24"
                  focusable="false"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
                  </g>
                </svg>
              </div>
              <div>
                <h2 className="_backHeading">{videoName}</h2>
                <div className="_backSub">
                  <div className="_backSubed">{meta}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <CarouselContentLoader></CarouselContentLoader>
      </div>
    );
  }
};

export default Watch;
